import React, { useState } from "react";

import { Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import { isEmpty, isEmptyString, toDownloadReportAddress } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar, Loader } from "../modules/BaseModule.js";
import { PopupInvoiceModule } from "../modules/ModuleUtil.js";

import { ConfigManager } from "../config/ConfigManager.js";
import {
  CheckPaymentHistoryPrintRequest,
  CustomerPaymentAgingHistoryCriteriaBean,
  RestPageListBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ShowError,
} from "../gui_components/UIComponents.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
class SalesPersonCurrentAging extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "SalesPerson Current Aging Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,

      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new CustomerPaymentAgingHistoryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,

      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      inquiryData: null,
      salesPersons: [],

      salesPersonPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesPersonList: true,
      is3PL: false,
    };
    this.salesPersonCodeRef = React.createRef();
  }
  componentDidMount() {
    //
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let salesPersons = attribute_cache.salesPersons;
    if (salesPersons != null || salesPersons != undefined) {
      salesPersons.map((attr) => {
        this.state.salesPersons.push(attr);
      });
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.state.salesPersons,
      "SalesPerson"
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    if (e.target.name == "salesPersonCode") {
      this.state.salesPersons.map((list, i) => {
        if (list.code == e.target.value) {
          criteria.salesPersonName = list.description;
        }
      });
    }
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    criteria.historyDate = currentDate;
    if (!isEmptyString(criteria.salesPersonCode)) {
      this.loadSalesPersonInquiryList(criteria);
    } else {
      let errMsg = "Invalid Input Criteria";
      let errorList = [];
      errorList.push(errMsg);
      this.setState({
        alertMessage: errorList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSalesPersonInquiryList = (criteria) => {
    this.setState({
      isLoading: true,
      loadingText: "Executing",
    });
    if (SecurityAccessManager.SalesPersonPaymentAgingInquiry_IsAccessible()) {
      ReportService.inquireCustomerPaymentCurrentAgingHistory(
        criteria,
        this.salesPersonCurrentAgingInquiryPageResponse,
        this.salesPersonCurrentAgingInquiryPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        loadingText: "",
      });
    }
  };
  salesPersonCurrentAgingInquiryPageResponse = (response) => {
    let inquiryDataList = response.data.result;
    /*let inquiryData =  response.data.result.infoBean;
	let checkAppliedInvoiceList = [];	
		 if(!isEmptyArray(response.data.result.checkAppliedInvoices)){
			 checkAppliedInvoiceList =  response.data.result.checkAppliedInvoices;
		 }	  
   if(!isEmptyArray(response.data.result.creditMemoAppliedInvoices)){
	   let creditMemoAppliedInvoiceList = response.data.result.creditMemoAppliedInvoices;
	   this.setState({creditMemoAppliedInvoiceList : creditMemoAppliedInvoiceList});
   }
  // let creditMemoData = null;
  // if(!isEmptyArray(response.data.result.creditMemoBean)){
	   let creditMemoData = response.data.result.creditMemoBean;
	  // creditMemoList.map(list =>{
		   //creditMemoData = list;
	 //  })
	  // this.setState({creditMemoList : creditMemoList});
 //  }*/

    if (inquiryDataList != null) {
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowPDFButton: false,
        isShowExcelButton: false,
        // inquiryDataList: checkAppliedInvoiceList,
        //inquiryData : inquiryData,
        //creditMemoData  :creditMemoData,
        //agingBucketList : agingBucketList,
        //pageList: pageList,
      });
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    } else {
      let errMsg = "No data Found";
      let errList = [];
      errList.push(errMsg);

      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        loadingText: "",
      });
      this.setState({
        isInquiryDatasFound: false,
      });
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    }
  };
  salesPersonCurrentAgingInquiryPageError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new CustomerPaymentAgingHistoryCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.salesPersonName = "";
    this.setState({ criteria: tempCriteria });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let tempCriteria = new CustomerPaymentAgingHistoryCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.salesPersonName = "";
    this.setState({
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");

    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    //criteria.historyDate = currentDate;

    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;

    let listRequest = new CheckPaymentHistoryPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.SalesPersonPaymentAgingInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCheckPaymentHistoryPrintReport(
          listRequest,
          this.generateSalesPersonPageResponse,
          this.generateSalesPersonPageError
        );
      } else {
        let errMsg = "PDF Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.SalesPersonPaymentAgingInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCheckPaymentHistoryPrintReport(
          listRequest,
          this.generateSalesPersonPageResponseForExcel,
          this.generateSalesPersonPageError
        );
      } else {
        let errMsg = "Excel Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  generateSalesPersonPageResponse = (response) => {
      this.showErrorMessage(response.data);
        if (response.data != null && response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            if (!isEmptyString(reportFilePath)) {
              window.open(this.report_url + reportFilePath);
            }
          }
        }
  };
    generateSalesPersonPageResponseForExcel = (response) => {
      this.showErrorMessage(response.data);
        if (response.data != null && response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            if (!isEmptyString(reportFilePath)) {
              let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
              window.open(downloadAddress, "_blank");
            }
          }
        }
  };
  generateSalesPersonPageError = (error) => {
    ShowError("Erro : " + error);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  viewInvoiceModule = (code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };

  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.showAutoCompleteSalesPersonList = true;

    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;

    if (isEmpty(salesPersonCode)) {
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      let criteria = this.state.criteria;
      criteria.salesPersonCode = "";
      criteria.salesPersonName = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });

    this.readSalesPerson(salesPersonCode);
  };

  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    //  let salesPersonList = [];
    this.state.salesPersons.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      temp_criteria.salesPersonName = salesPersonBean.description;
      this.state.showAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesPersonList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    // salesPersonList.push(salesPersonBean);
    this.setState({ salesPersonList: salesPersonBean });
  };

  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersons;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };

  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteSalesPersonList: showAutoCompleteList });
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let isLoading = this.state.isLoading;
    let inquiryData = this.state.inquiryData;

    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />

        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          salesPersonLookupHandler={this.state.salesPersonLookupHandler}
          salesPersonCodeRef={this.salesPersonCodeRef}
          salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
          displayAutoCompleteSalesPersonList={
            this.displayAutoCompleteSalesPersonList
          }
          salesPersonCodeOnChange={this.salesPersonCodeOnChange}
        />

        {/*this.state.isInquiryDatasFound ? (
	        <BaseInquiryPageListToolBar	        
	        />
	     
	      ) : null*/}
        {isLoading ? <Loader /> : null}

        {this.state.isInquiryDatasFound && (
          <div>
            <div className="header_div col-md-12 col-lg-12">
              <FormLabel> CreditMemo Applied Invoice Details</FormLabel>

              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th>AR#</th>
                    <th>PO#</th>
                    <th>InvoiceDate</th>
                    <th>Invoice#</th>
                    <th>OpenInvoiceAmt</th>
                    <th>TotalAppliedAmt</th>
                    <th>AppliedAmt</th>
                    <th>CM Applied</th>
                  </tr>
                </thead>
                {/*inquiryDataList.map((inquiryInfo, index) => (  
	        <tbody > 	       	         
	              <tr key={index}>	                
	                <td>
	                <Button
	                  variant="secondry"
	                  className="hyperLinkText"
	                 // onClick={() => this.viewInvoiceModule(inquiryInfo.accountReceivableNumber)}
	                >
	                  {inquiryInfo.accountReceivableNumber}
	                </Button>
	                </td>
	                <td>{inquiryInfo.customerPurchaseOrderNumber}</td>	               
	                <td>{this.getFormattedDate(inquiryInfo.invoiceDate)}</td>	
	                <td>
	                <Button
	                  variant="secondry"
	                  className="hyperLinkText"
	                  onClick={() => this.viewInvoiceModule(inquiryInfo.invoiceNumber)}
	                >
	                  {inquiryInfo.invoiceNumber}
	                </Button>
	                </td>	                
	                <td>{inquiryInfo.openInvoiceAmount}</td> 
	                <td>{inquiryInfo.totalAppliedAmount}</td>     
	                <td>{inquiryInfo.appliedAmount}</td>   
	                <td>{inquiryInfo.creditMemoAppliedAmount}</td>   
	              </tr>
	       
	        </tbody>
	        ))*/}
              </Table>
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };

  let criteria = props.criteria;

  let salesPersonLookupHandler = props.salesPersonLookupHandler;
  //let salesPersonCodeRef = React.createRef();
  const salesPersonCodeRef = props.salesPersonCodeRef;
  // if (salesPersonCodeRef.current != null) {
  //   salesPersonCodeRef.current.focus();
  // }
  let isInquiryDatasFound = props.isInquiryDatasFound;
  let inquiryData = props.inquiryData;
  const salesPersonEnterKeyEventHandler = (e) => {
    props.salesPersonEnterKeyEventHandler(e);
  };

  const displayAutoCompleteSalesPersonList = () => {
    props.displayAutoCompleteSalesPersonList();
  };
  const salesPersonCodeOnChange = (e) => {
    props.salesPersonCodeOnChange(e);
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>SalesPersonCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={salesPersonCodeRef}
            name="salesPersonCode"
            onChange={salesPersonCodeOnChange}
            value={criteria.salesPersonCode}
            lookupRequired={true}
            lookupHandler={salesPersonLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={salesPersonEnterKeyEventHandler}
            autoCompleteListData={props.salesPersonPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesPersonList}
            showAutoCompleteList={props.showAutoCompleteSalesPersonList}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="salesPersonName"
            onChange={onChange}
            value={criteria.salesPersonName}
            disabled={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function SalesPersonCurrentAgingInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <SalesPersonCurrentAging {...props} name="" /> <br />
    </div>
  );
}

export default SalesPersonCurrentAgingInquiry;
